module.exports = __webpack_public_path__ + "media/images/shark/Chippy-p-800-f6f12834dc0db468a3678d2296d27ef5.jpeg";